<script setup lang="ts">
defineProps<{
  item: StoryBlokArticle
}>()

const appConfig = useAppConfig()
const blog = appConfig.blog
const adviser = appConfig.adviser
</script>

<template>
  <StoryblokLink
    :to="`${item?.content?.component === 'adviserArticle' ? `${adviser?.url}` : blog.url}/${item?.slug}`"
    class="relative flex flex-col md:flex-row rounded-xl overflow-hidden bg-white border border-gray mb-5 shadow-pasive transition ease-in-out hover:shadow-hover hover:border-hover"
  >
    <div v-if="item?.content?.image" class="min-w-250px h-full overflow-hidden">
      <StoryblokImage :src="item?.content?.image" width="270" height="300" mwidth="780" mheight="335" class="w-full h-auto md:max-w-250px md:h-auto md:w-auto md:absolute" />
    </div>
    <div class="p-5 flex flex-col">
      <h4>{{ item?.content?.title }}</h4>
      <div v-if="item?.content?.changeDate || item?.content?.publishDate" class="text-gray-dark flex py-3 text-sm">
        <span>{{ useFormatDate(item?.content?.publishDate, 'd. M. yyyy') }}</span>
        <span v-if="item?.content?.readTime" class="px-2.5">|</span>
        <div v-if="item?.content?.readTime">
          {{ blog.articleLength }}: {{ item?.content?.readTime }} min.
        </div>
      </div>
      <div class="flex-1 hidden sm:block mb-2.5">
        <StoryblokRichText v-if="item?.content?.perex" :document="item?.content?.perex" class="text text-sm line-clamp-5 md:line-clamp-3 overflow-hidden leading-22px" />
      </div>
      <object v-if="item?.content?.tags" class="flex flex-wrap gap-2.5 ">
        <StoryblokLink
          v-for="(tag, j) in item?.content?.tags"
          :key="j"
          :to="`${blog.url}/tag/${tag?.slug}`"
          class="text-sm text-secondary-active font-medium flex-shrink-0 relative z-1"
        >
          #{{ tag?.name }}
        </StoryblokLink>
      </object>
    </div>
  </StoryblokLink>
</template>
